/** InsCoder WANG.J 2026-10-20 B + PRO kit price comparison responsive storefront section **/
if (!customElements.get('cust-pro-kit')) {
 customElements.define('cust-pro-kit', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   const toggle = this.querySelector('.cust-pro-kit__toggle');
   if (!toggle) return;
   toggle.hidden = false;
   /** InsCoder WANG.J 2026-10-21 B + Keep mobile pricing on PRO when its desktop-only toggle is hidden **/
   this.setMode = (pro) => {
    toggle.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.mode === (pro ? 'pro' : 'retail'))));
    this.querySelectorAll('[data-pro-price],[data-retail-compare]').forEach(item => { item.hidden = !pro; });
    this.querySelectorAll('[data-retail-price]').forEach(item => { item.hidden = pro; });
   };
   this.mobile = window.matchMedia('(max-width: 768px)');
   this.onBreakpoint = () => { if (this.mobile.matches) this.setMode(true); };
   this.mobile.addEventListener('change', this.onBreakpoint);
   this.onBreakpoint();
   /** InsCoder WANG.J 2026-10-21 E + Keep mobile pricing on PRO when its desktop-only toggle is hidden **/
   this.onClick = (event) => {
    const button = event.target.closest('button[data-mode]');
    if (!button || !toggle.contains(button)) return;
    this.setMode(button.dataset.mode === 'pro');
   };
   toggle.addEventListener('click', this.onClick);
  }
  disconnectedCallback() {
   this.querySelector('.cust-pro-kit__toggle')?.removeEventListener('click', this.onClick);
   this.mobile?.removeEventListener('change', this.onBreakpoint);
   this.initialized = false;
  }
 });
}
/** InsCoder WANG.J 2026-10-20 E + PRO kit price comparison responsive storefront section **/
